import { render, staticRenderFns } from "./Ozne.vue?vue&type=template&id=5d0d7ad7&"
import script from "./Ozne.vue?vue&type=script&lang=js&"
export * from "./Ozne.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports